import React                  from 'react';
import { Modal, ModalManager} from 'react-dynamic-modal';

class DynamicModal extends React.Component {
    
  constructor(props) {
    super(props);
    this.ok    = this.ok.bind(this);
    this.close = this.close.bind(this);
  }

  ok() {
    const {ok} = this.props;
    ModalManager.close();
    ok();
  }
  
  close() {
    const {cancel} = this.props;
    ModalManager.close();
    if (cancel) { cancel(); }
  }

  render() {
    const {content, effect, title} = this.props;
    return (
      <Modal
        effect={effect}
        onRequestClose={ () => true }>
          <div className="modal-header">
            <h4 className="modal-title">{title}</h4>
          </div>
          <div className="modal-body">
            {content}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={this.close}>Close</button>
            <button type="button" className="btn btn-primary" onClick={this.ok}>OK</button>
          </div>
      </Modal>
    );
  }
}

export default DynamicModal;
